import { format } from "date-fns";

export const toLocalISOString = (date) => {
  return format(date, "yyyy-MM-dd'T'HH:mm");
};
